import Track from "../Track/Track";
import "./DisplayCup.css";

export default function DisplayYourCup(props) {

    return <ul className="tracks-background" id="your-cup">
        {
            props.tracks &&
            props.tracks.map((element, index) => {
                return <Track
                    track={element}
                    index={index}
                    yourCup={true}
                    size={props.width <= 1120 ? props.selectTrack !== index ? "small" : "medium"
                        : "big"}
                    select={props.selectTrack === index}
                    showCursor={false}
                    key={index}
                    tabIndex={-1}
                />
            })
        }
    </ul>
}